import { useMutation } from 'react-query';

import { removeUser } from 'shared/api/users/http';

const useMutateRemoveUser = (options = undefined) => useMutation(removeUser, options);

export default useMutateRemoveUser;
